// ======================================================================
// File: CRMAnalyticsDashboard.js
// Purpose:
// CRM Analytics Dashboard
// Strategic Analytics & Forecasting
// ======================================================================

import React from "react";

export default function CRMAnalyticsDashboard() {
  return (
    <div>

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={{
          background:
            "linear-gradient(135deg,#7c3aed,#8b5cf6)",
          borderRadius: "16px",
          padding: "20px",
          color: "#fff",
          marginBottom: "24px",
          boxShadow:
            "0 8px 24px rgba(124,58,237,.25)",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontWeight: 700,
          }}
        >
          CRM Analytics Dashboard
        </h2>

        <div
          style={{
            marginTop: "8px",
            opacity: 0.9,
          }}
        >
          Sales Analytics, Funnel Analytics,
          Customer Analytics and Revenue Forecasting
        </div>
      </div>

      {/* =====================================================
          KPI SECTION
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(220px,1fr))",
          gap: "16px",
          marginBottom: "24px",
        }}
      >

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Total Revenue
          </div>

          <div
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#16a34a",
              marginTop: "8px",
            }}
          >
            ₹28.6 Cr
          </div>
        </div>

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Conversion Rate
          </div>

          <div
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#2563eb",
              marginTop: "8px",
            }}
          >
            67%
          </div>
        </div>

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Average Deal Size
          </div>

          <div
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#7c3aed",
              marginTop: "8px",
            }}
          >
            ₹42L
          </div>
        </div>

        <div
          className="card"
          style={{
            padding: "18px",
            borderRadius: "12px",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
            }}
          >
            Sales Cycle
          </div>

          <div
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#f59e0b",
              marginTop: "8px",
            }}
          >
            42 Days
          </div>
        </div>

      </div>

      {/* =====================================================
    REVENUE ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* =====================================================
      REVENUE TREND
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent:
          "space-between",
        marginBottom: "16px",
      }}
    >
      <h4
        style={{
          margin: 0,
        }}
      >
        Revenue Trend
      </h4>

      <span
        style={{
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        Last 12 Months
      </span>
    </div>

    {[
      { month: "Jan", value: 12 },
      { month: "Feb", value: 18 },
      { month: "Mar", value: 22 },
      { month: "Apr", value: 28 },
      { month: "May", value: 35 },
      { month: "Jun", value: 42 },
    ].map((item) => (
      <div
        key={item.month}
        style={{
          marginBottom: "12px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "4px",
          }}
        >
          <span>{item.month}</span>
          <strong>
            ₹{item.value}L
          </strong>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.value * 2}%`,
              height: "100%",
              background:
                "linear-gradient(90deg,#7c3aed,#8b5cf6)",
            }}
          />
        </div>
      </div>
    ))}
  </div>

  {/* =====================================================
      QUARTERLY REVENUE
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "20px",
      }}
    >
      Quarterly Revenue Analysis
    </h4>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            background: "#f8fafc",
          }}
        >
          <th
            style={{
              padding: "12px",
              textAlign: "left",
            }}
          >
            Quarter
          </th>

          <th
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            Revenue
          </th>

          <th
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            Growth
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td style={{ padding: "12px" }}>
            Q1
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            ₹4.8 Cr
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
              color: "#16a34a",
              fontWeight: 700,
            }}
          >
            +12%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "12px" }}>
            Q2
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            ₹6.2 Cr
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
              color: "#16a34a",
              fontWeight: 700,
            }}
          >
            +18%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "12px" }}>
            Q3
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            ₹7.4 Cr
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
              color: "#16a34a",
              fontWeight: 700,
            }}
          >
            +14%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "12px" }}>
            Q4
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
            }}
          >
            ₹10.2 Cr
          </td>

          <td
            style={{
              padding: "12px",
              textAlign: "right",
              color: "#16a34a",
              fontWeight: 700,
            }}
          >
            +22%
          </td>
        </tr>

      </tbody>
    </table>
  </div>

</div>

{/* =====================================================
    LEAD SOURCE + FUNNEL ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* =====================================================
      LEAD SOURCE ANALYTICS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Lead Source Analytics
    </h4>

    {[
      {
        source: "Website",
        leads: 180,
        revenue: "₹4.8 Cr",
        color: "#2563eb",
      },
      {
        source: "Referral",
        leads: 120,
        revenue: "₹6.2 Cr",
        color: "#16a34a",
      },
      {
        source: "Direct Sales",
        leads: 90,
        revenue: "₹8.4 Cr",
        color: "#7c3aed",
      },
      {
        source: "Partner Network",
        leads: 65,
        revenue: "₹3.1 Cr",
        color: "#f59e0b",
      },
    ].map((row) => (
      <div
        key={row.source}
        style={{
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "6px",
          }}
        >
          <strong>
            {row.source}
          </strong>

          <span>
            {row.revenue}
          </span>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${row.leads / 2}%`,
              height: "100%",
              background: row.color,
            }}
          />
        </div>

        <div
          style={{
            marginTop: "4px",
            fontSize: "12px",
            color: "#64748b",
          }}
        >
          {row.leads} Leads
        </div>
      </div>
    ))}
  </div>

  {/* =====================================================
      SALES FUNNEL ANALYTICS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Sales Funnel Analytics
    </h4>

    {[
      {
        stage: "Lead",
        count: 500,
        color: "#2563eb",
      },
      {
        stage: "Qualified",
        count: 320,
        color: "#7c3aed",
      },
      {
        stage: "Proposal",
        count: 180,
        color: "#f59e0b",
      },
      {
        stage: "Negotiation",
        count: 85,
        color: "#ef4444",
      },
      {
        stage: "Won",
        count: 62,
        color: "#16a34a",
      },
    ].map((item, index, arr) => {

      const conversion =
        index > 0
          ? (
              (item.count /
                arr[index - 1].count) *
              100
            ).toFixed(1)
          : null;

      return (
        <div
          key={item.stage}
          style={{
            marginBottom: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent:
                "space-between",
              marginBottom: "6px",
            }}
          >
            <strong>
              {item.stage}
            </strong>

            <span>
              {item.count}
            </span>
          </div>

          <div
            style={{
              height: "12px",
              background: "#e5e7eb",
              borderRadius: "999px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${
                  (item.count / 500) *
                  100
                }%`,
                height: "100%",
                background:
                  item.color,
              }}
            />
          </div>

          {conversion && (
            <div
              style={{
                marginTop: "4px",
                fontSize: "12px",
                color: "#64748b",
              }}
            >
              Conversion:
              <strong>
                {" "}
                {conversion}%
              </strong>
            </div>
          )}
        </div>
      );
    })}
  </div>

</div>
{/* =====================================================
    CUSTOMER + PRODUCT ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* =====================================================
      CUSTOMER ANALYTICS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Customer Revenue Contribution
    </h4>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            background: "#f8fafc",
          }}
        >
          <th
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            Customer
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            Revenue
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            %
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td style={{ padding: "10px" }}>
            L&T
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            ₹5.2 Cr
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            24%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Tata Projects
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            ₹4.1 Cr
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            19%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Adani
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            ₹3.8 Cr
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            17%
          </td>
        </tr>

      </tbody>
    </table>

    <div
      style={{
        marginTop: "18px",
        padding: "12px",
        background: "#f8fafc",
        borderRadius: "10px",
      }}
    >
      Customer Retention Rate:
      <strong>
        {" "}
        87%
      </strong>
    </div>
  </div>

  {/* =====================================================
      PRODUCT ANALYTICS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Product Revenue Analysis
    </h4>

    {[
      {
        product: "Transformer",
        revenue: 90,
        color: "#2563eb",
      },
      {
        product: "Control Panel",
        revenue: 75,
        color: "#7c3aed",
      },
      {
        product: "Switchgear",
        revenue: 60,
        color: "#f59e0b",
      },
      {
        product: "Solar Package",
        revenue: 45,
        color: "#16a34a",
      },
    ].map((item) => (
      <div
        key={item.product}
        style={{
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "4px",
          }}
        >
          <strong>
            {item.product}
          </strong>

          <span>
            ₹{item.revenue}L
          </span>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.revenue}%`,
              height: "100%",
              background:
                item.color,
            }}
          />
        </div>
      </div>
    ))}

    <div
      style={{
        marginTop: "18px",
        display: "grid",
        gridTemplateColumns:
          "1fr 1fr",
        gap: "12px",
      }}
    >
      <div
        style={{
          background: "#f8fafc",
          padding: "12px",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "#64748b",
          }}
        >
          Top Product
        </div>

        <div
          style={{
            fontWeight: 700,
            marginTop: "4px",
          }}
        >
          Transformer
        </div>
      </div>

      <div
        style={{
          background: "#f8fafc",
          padding: "12px",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "#64748b",
          }}
        >
          Avg Margin
        </div>

        <div
          style={{
            fontWeight: 700,
            marginTop: "4px",
            color: "#16a34a",
          }}
        >
          28%
        </div>
      </div>
    </div>
  </div>

</div>
{/* =====================================================
    WIN/LOSS + SALES TEAM ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* =====================================================
      WIN / LOSS ANALYSIS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Win / Loss Analysis
    </h4>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "12px",
        marginBottom: "18px",
      }}
    >
      <div
        style={{
          background: "#dcfce7",
          padding: "16px",
          borderRadius: "12px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "#166534",
          }}
        >
          Won Opportunities
        </div>

        <div
          style={{
            fontSize: "32px",
            fontWeight: 700,
            color: "#166534",
          }}
        >
          62
        </div>
      </div>

      <div
        style={{
          background: "#fee2e2",
          padding: "16px",
          borderRadius: "12px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            color: "#991b1b",
          }}
        >
          Lost Opportunities
        </div>

        <div
          style={{
            fontSize: "32px",
            fontWeight: 700,
            color: "#991b1b",
          }}
        >
          18
        </div>
      </div>
    </div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            background: "#f8fafc",
          }}
        >
          <th
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            Loss Reason
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            Count
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td style={{ padding: "10px" }}>
            Price
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            8
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Competitor
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            5
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>
            Budget Issue
          </td>
          <td
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            3
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  {/* =====================================================
      SALES TEAM PERFORMANCE
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Sales Team Performance
    </h4>

    {[
      {
        name: "Amit Kumar",
        revenue: 82,
        color: "#2563eb",
      },
      {
        name: "Rahul Sharma",
        revenue: 68,
        color: "#7c3aed",
      },
      {
        name: "Suresh Rao",
        revenue: 55,
        color: "#16a34a",
      },
      {
        name: "Vijay Patel",
        revenue: 42,
        color: "#f59e0b",
      },
    ].map((item) => (
      <div
        key={item.name}
        style={{
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "4px",
          }}
        >
          <strong>
            {item.name}
          </strong>

          <span>
            ₹{item.revenue}L
          </span>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.revenue}%`,
              height: "100%",
              background:
                item.color,
            }}
          />
        </div>
      </div>
    ))}

    <div
      style={{
        marginTop: "20px",
        padding: "12px",
        background: "#f8fafc",
        borderRadius: "10px",
      }}
    >
      Best Performer :
      <strong>
        {" "}
        Amit Kumar
      </strong>
    </div>
  </div>

</div>
{/* =====================================================
    REGIONAL + FORECAST ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* =====================================================
      REGIONAL SALES ANALYTICS
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Regional Sales Performance
    </h4>

    {[
      {
        region: "South",
        revenue: 92,
        color: "#2563eb",
      },
      {
        region: "West",
        revenue: 78,
        color: "#16a34a",
      },
      {
        region: "North",
        revenue: 61,
        color: "#7c3aed",
      },
      {
        region: "East",
        revenue: 44,
        color: "#f59e0b",
      },
    ].map((item) => (
      <div
        key={item.region}
        style={{
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            marginBottom: "4px",
          }}
        >
          <strong>
            {item.region}
          </strong>

          <span>
            ₹{item.revenue} Cr
          </span>
        </div>

        <div
          style={{
            height: "10px",
            background: "#e5e7eb",
            borderRadius: "999px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${item.revenue}%`,
              height: "100%",
              background:
                item.color,
            }}
          />
        </div>
      </div>
    ))}
  </div>

  {/* =====================================================
      TARGET VS ACHIEVEMENT
  ===================================================== */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Target vs Achievement
    </h4>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            background: "#f8fafc",
          }}
        >
          <th
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            Month
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            Target
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            Achieved
          </th>

          <th
            style={{
              padding: "10px",
              textAlign: "right",
            }}
          >
            %
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td style={{ padding: "10px" }}>Jan</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹12 Cr</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹11 Cr</td>
          <td style={{ padding: "10px", textAlign: "right" }}>92%</td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>Feb</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹14 Cr</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹15 Cr</td>
          <td style={{ padding: "10px", textAlign: "right", color:"#16a34a" }}>
            107%
          </td>
        </tr>

        <tr>
          <td style={{ padding: "10px" }}>Mar</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹16 Cr</td>
          <td style={{ padding: "10px", textAlign: "right" }}>₹13 Cr</td>
          <td style={{ padding: "10px", textAlign: "right", color:"#dc2626" }}>
            81%
          </td>
        </tr>

      </tbody>
    </table>
  </div>

</div>
{/* =====================================================
    AGING ANALYTICS
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* QUOTATION AGING */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Quotation Aging Analysis
    </h4>

    {[
      { days: "0-7 Days", count: 24 },
      { days: "8-15 Days", count: 18 },
      { days: "16-30 Days", count: 11 },
      { days: "31+ Days", count: 7 },
    ].map((item) => (
      <div
        key={item.days}
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          padding: "10px 0",
          borderBottom:
            "1px solid #f1f5f9",
        }}
      >
        <span>{item.days}</span>
        <strong>{item.count}</strong>
      </div>
    ))}
  </div>

  {/* SALES CYCLE */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Sales Cycle Analysis
    </h4>

    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "1fr 1fr",
        gap: "12px",
      }}
    >
      <div className="card p-3">
        Avg Cycle
        <h3>42 Days</h3>
      </div>

      <div className="card p-3">
        Fastest Deal
        <h3>9 Days</h3>
      </div>

      <div className="card p-3">
        Longest Deal
        <h3>118 Days</h3>
      </div>

      <div className="card p-3">
        Conversion Rate
        <h3>67%</h3>
      </div>
    </div>
  </div>

</div>
{/* =====================================================
    OPPORTUNITY MANAGEMENT
===================================================== */}

<div
  style={{
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(500px,1fr))",
    gap: "16px",
    marginBottom: "24px",
  }}
>

  {/* TOP OPPORTUNITIES */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
      }}
    >
      Top Opportunities
    </h4>

    <table
      style={{
        width: "100%",
      }}
    >
      <tbody>

        <tr>
          <td>L&T Substation</td>
          <td>₹4.2 Cr</td>
          <td>Negotiation</td>
        </tr>

        <tr>
          <td>Tata Solar</td>
          <td>₹3.8 Cr</td>
          <td>Proposal</td>
        </tr>

        <tr>
          <td>Adani Grid</td>
          <td>₹2.9 Cr</td>
          <td>Qualified</td>
        </tr>

      </tbody>
    </table>
  </div>

  {/* RISK OPPORTUNITIES */}

  <div
    className="card"
    style={{
      padding: "18px",
      borderRadius: "12px",
    }}
  >
    <h4
      style={{
        marginTop: 0,
        marginBottom: "18px",
        color: "#dc2626",
      }}
    >
      Risk Opportunities
    </h4>

    <table
      style={{
        width: "100%",
      }}
    >
      <tbody>

        <tr>
          <td>ABC Power</td>
          <td>₹2.2 Cr</td>
          <td>45 Days No Activity</td>
        </tr>

        <tr>
          <td>XYZ Infra</td>
          <td>₹1.4 Cr</td>
          <td>Quotation Expired</td>
        </tr>

        <tr>
          <td>PQR Energy</td>
          <td>₹1.1 Cr</td>
          <td>Delayed Follow-up</td>
        </tr>

      </tbody>
    </table>
  </div>

</div>
{/* =====================================================
    EXECUTIVE ACTION CENTER
===================================================== */}

<div
  className="card"
  style={{
    padding: "18px",
    borderRadius: "12px",
    marginBottom: "24px",
  }}
>
  <h4
    style={{
      marginTop: 0,
      marginBottom: "18px",
    }}
  >
    Executive Action Center
  </h4>

  <div
    style={{
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit,minmax(250px,1fr))",
      gap: "16px",
    }}
  >

    <div
      style={{
        background: "#fee2e2",
        padding: "16px",
        borderRadius: "12px",
      }}
    >
      🔴 7 High Value Opportunities Need Attention
    </div>

    <div
      style={{
        background: "#fef3c7",
        padding: "16px",
        borderRadius: "12px",
      }}
    >
      🟡 12 Quotations Pending Approval
    </div>

    <div
      style={{
        background: "#dbeafe",
        padding: "16px",
        borderRadius: "12px",
      }}
    >
      🔵 9 Follow-ups Due Today
    </div>

    <div
      style={{
        background: "#dcfce7",
        padding: "16px",
        borderRadius: "12px",
      }}
    >
      🟢 Forecast Above Target by 8%
    </div>

  </div>
</div>
{/* =====================================================
    AI INSIGHTS
===================================================== */}

<div
  className="card"
  style={{
    padding: "18px",
    borderRadius: "12px",
    marginBottom: "24px",
  }}
>
  <h4
    style={{
      marginTop: 0,
      marginBottom: "18px",
    }}
  >
    AI Insights & Recommendations
  </h4>

  <ul
    style={{
      lineHeight: "2",
      paddingLeft: "20px",
    }}
  >
    <li>
      South Region contributes 42% of total revenue.
    </li>

    <li>
      L&T generated highest revenue this quarter.
    </li>

    <li>
      7 opportunities are at risk due to inactivity.
    </li>

    <li>
      Quotation conversion improved by 11%.
    </li>

    <li>
      Forecast indicates target achievement at 108%.
    </li>
  </ul>
</div>
      {/* =====================================================
          PLACEHOLDER
      ===================================================== */}

      <div
        className="card"
        style={{
          padding: "30px",
          borderRadius: "12px",
          textAlign: "center",
        }}
      >
        Revenue Analytics,
        Funnel Analytics,
        Customer Analytics and Forecasting
        widgets will be added in the next steps.
      </div>

    </div>
  );
}